import React from 'react';
import {
    Box,
    Typography,
    Grid,
    Paper,
    Divider
} from '@mui/material';
import { useFormularioSecretariaMunicipalAgriculturaStore } from 'stores/forms/formularioAgricultura.store';

const Step1View: React.FC = () => {
    const { formulario } = useFormularioSecretariaMunicipalAgriculturaStore();

    if (!formulario) {
        return (
            <Box display="flex" justifyContent="center" p={3}>
                <Typography>Carregando informações...</Typography>
            </Box>
        );
    }

    const InfoField: React.FC<{ label: string; value: any }> = ({ label, value }) => (
        <Box mb={2}>
            <Typography variant="subtitle2" color="textSecondary" gutterBottom>
                {label}
            </Typography>
            <Typography variant="body1">
                {value || 'Não informado'}
            </Typography>
        </Box>
    );

    return (
        <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
            <Typography variant="h5" gutterBottom color="primary">
                Informações Gerais
            </Typography>

            <Divider sx={{ mb: 3 }} />

            <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Nome da Secretaria/Órgão"
                        value={formulario.nome_secretaria}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Ano de Referência"
                        value={formulario.ano_referencia}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Endereço"
                        value={formulario.endereco}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Número"
                        value={formulario.endereco_numero}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Bairro"
                        value={formulario.bairro}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="CEP"
                        value={formulario.cep}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Email da Secretaria"
                        value={formulario.email}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Telefone"
                        value={formulario.telefone}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Telefone 2"
                        value={formulario.telefone2}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Nome do Responsável"
                        value={formulario.nome_responsavel}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <InfoField
                        label="Email do Responsável"
                        value={formulario.email_responsavel}
                    />
                </Grid>
            </Grid>
        </Paper>
    );
};

export default Step1View; 